import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  SzButtonComponent,
  SzBottomSheetComponent,
  SzIconComponent,
  SzIconButtonComponent,
  SzLiveDotComponent
} from '@ui';
import { RunInput } from '../../application/state';
import { NumpadRepsComponent } from './numpad-reps/numpad-reps.component';
import { NumpadTprComponent } from './numpad-tpr/numpad-tpr.component';
import { NumpadSheetContext, NumpadSheetMode, NumpadSheetVariant } from './numpad-sheet.types';

@Component({
  selector: 'lib-numpad-sheet',
  templateUrl: './numpad-sheet.component.html',
  styleUrls: ['./numpad-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslateModule,
    SzBottomSheetComponent,
    SzButtonComponent,
    SzIconButtonComponent,
    SzIconComponent,
    SzLiveDotComponent,
    NumpadRepsComponent,
    NumpadTprComponent
  ]
})
export class NumpadSheetComponent {
  readonly open: InputSignal<boolean> = input.required<boolean>();
  readonly variant: InputSignal<NumpadSheetVariant> = input.required<NumpadSheetVariant>();
  readonly mode: InputSignal<NumpadSheetMode> = input<NumpadSheetMode>('add');
  readonly context: InputSignal<NumpadSheetContext | null> = input<NumpadSheetContext | null>(null);
  readonly initialPayload: InputSignal<RunInput | null> = input<RunInput | null>(null);
  readonly resetTrigger: InputSignal<number> = input<number>(0);

  @Output() readonly close: EventEmitter<void> = new EventEmitter<void>();
  @Output() readonly submitRun: EventEmitter<RunInput> = new EventEmitter<RunInput>();
  @Output() readonly deleteRun: EventEmitter<void> = new EventEmitter<void>();

  onVariantSubmit(payload: RunInput): void {
    this.submitRun.emit(payload);
  }

  onVariantCancel(): void {
    this.close.emit();
  }

  onDeleteClick(): void {
    this.deleteRun.emit();
  }

  formatRun(runNumber: number): string {
    return runNumber.toString().padStart(2, '0');
  }
}
